var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRefreshClockSuccess = function SvgRefreshClockSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 -3 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5615",
    "data-name": "Grupo 5615",
    transform: "translate(-231.814 -229.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5587",
    "data-name": "Grupo 5587",
    transform: "translate(240.65 235.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4388",
    "data-name": "Caminho 4388",
    d: "M246.605,235.548h-.013a6.239,6.239,0,1,0,.013,0Zm3.049,9.532-3.977-2.387v-4.559h1.776v3.619l3.1,1.843Z",
    transform: "translate(-240.36 -235.548)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_17",
    "data-name": "Subtra\\xE7\\xE3o 17",
    d: "M19376.582,3304.829c-.238,0-.475-.009-.723-.019h-.012a11.79,11.79,0,0,1-11.053-11.749v-.433h-2.486l3.406-5.7,3.412,5.7h-2.488v.433a9.935,9.935,0,0,0,9.924,9.924,9.808,9.808,0,0,0,6.051-2.057v2.231A11.692,11.692,0,0,1,19376.582,3304.829Z",
    transform: "translate(-19129.613 -3051)",
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_18",
    "data-name": "Subtra\\xE7\\xE3o 18",
    d: "M14.273,17.9c-.238,0-.475-.009-.723-.019h-.012A11.79,11.79,0,0,1,2.486,6.132V5.7H0L3.406,0,6.818,5.7H4.33v.433a9.935,9.935,0,0,0,9.924,9.924A9.808,9.808,0,0,0,20.3,14v2.231A11.692,11.692,0,0,1,14.273,17.9Z",
    transform: "translate(261 247.829) rotate(180)",
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefreshClockSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh-clock-success.3145296b.svg";
export { ForwardRef as ReactComponent };